import {
  EEventsViewActions,
  EventsViewActions,
} from '@myStore/events-view/events-view.actions';
import {
  IEventsViewState,
  initialEventsViewState,
} from '@myStore/events-view/events-view.state';

export const eventsViewReducers = (
  state = initialEventsViewState,
  action: EventsViewActions
): IEventsViewState => {
  switch (action.type) {
    case EEventsViewActions.GetEventRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EEventsViewActions.GetEventSuccess:
      if (action.payload.newFile) {
        return {
          ...state,
          event: {
            ...state.event,
            files: [...state.event.files, action.payload.files[0]],
          },
        };
      }

      return {
        ...state,
        event: {
          ...state.event,
          ...action.payload,
        },
        isLoading: false,
      };
    case EEventsViewActions.GetEventFailure:
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case EEventsViewActions.GetEventsRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EEventsViewActions.GetEventsSuccess:
      return {
        ...state,
        pagination: action.payload,
        isLoading: false,
      };
    case EEventsViewActions.GetEventsFailure:
      return {
        ...state,
        isLoading: false,
        errors: action.error,
      };
    case EEventsViewActions.ClearEvents:
      return {
        ...state,
        errors: null,
        pagination: null,
      };
    case EEventsViewActions.GetEventsByPeriodRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EEventsViewActions.GetEventsByPeriodSuccess:
      return {
        ...state,
        events: action.events,
        isLoading: false,
      };
    case EEventsViewActions.GetEventsByPeriodFailure:
      return {
        ...state,
        isLoading: false,
        errors: action.errors,
      };
    case EEventsViewActions.ClearGetEventsByPeriod:
      return {
        ...state,
        errors: null,
        events: null,
      };

    case EEventsViewActions.SetCurrentEvent:
      return { ...state, currentEvent: action.event };
    case EEventsViewActions.ClearCurrentEvent:
      return { ...state, currentEvent: null };

    default:
      return state;
  }
};
